$(window).ready(function() {
    $(".se-pre-con").fadeOut("fast");

});
$(window).bind('beforeunload', function () {
    $(".se-pre-con").fadeIn("fast");
});

$('form').on('submit', function( event ) {
    const submitButton = $(this).find('button[type="submit"]');
    if(submitButton.length) {
        const buttonContent = submitButton.html();
        submitButton.prop('disabled', true);
        submitButton.html('<i class="fa-sharp fa-light fa-loader fa-spin"></i> Loading...');
        setTimeout(function () {
            submitButton.prop('disabled', false);
            submitButton.html(buttonContent);
        }, 5000)
    }
});
